"use client";

import React from "react";
import Section from "@/components/static/Section";
import parse from "html-react-parser/lib/index";
import Post from "@/components/static/PostCard";
import useSWR from "swr";
import { useState, useEffect } from "react";
import Loader from "@/components/static/Loader";
import Headline from "@/components/static/Headline";
import Button from "@/components/static/Button";
import Text from "@/components/static/Text";
import { SectionProps, HeadlineProps, TermProps, PostProps, LinkProps } from "@/lib/types";
import FirstPost from "@/components/static/FirstPostCard";

export type Content = {
    acf_fc_layout: string;
    icon: {
        url: string;
        alt: string;
        width: number;
        height: number;
    };
    headline: HeadlineProps;
    text: string;
    settings: {
        category: number;
        number: number;
        buttonAllPosts: LinkProps;
        firstBig: boolean;
    } & SectionProps;
};

export default function Blog_34({
    content,
    translations,
    locale,
}: {
    content: Content;
    translations: any;
    locale: string;
}) {
    const [total, setTotal] = useState(0);
    const [posts, setPosts] = useState<PostProps[]>([]);
    const [perPage, setPerPage] = useState(99);
    const [category, setCategory] = useState<boolean | number>(false);

    if (content.settings?.category && category != content.settings?.category) {
        setCategory(content.settings?.category);
    }

    const { data: categoriesData } = useSWR<TermProps[]>(
        `wp/v2/categories?exclude=8,28&_fields=name,slug,id`,
        async (url: string) => {
            const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}${url}`, {});
            const data = await response.json();
            return data;
        }
    );

    const { data, isLoading } = useSWR<{ data: PostProps[]; total: number }>(
        category
            ? `wp/v2/posts?per_page=${perPage}&categories=${category}&_embed=&acf_format=standard&lang=${locale}`
            : `wp/v2/posts?per_page=${perPage}&categories_exclude=28&_embed=&acf_format=standard&lang=${locale}`,
        async (url: string) => {
            const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}${url}`, {});
            const data = await response.json();
            return {
                data: data,
                total: parseInt(response.headers.get("x-wp-total") || "0"),
            };
        }
    );

    useEffect(() => {
        if (data) {
            setPosts(data.data);
            setTotal(data.total);
        }
    }, [data]);

    return (
        <Section dataComponent='Blog_34' settings={content.settings} preventAnimation={true}>
            <div className='container'>
                <div className='flex items-center flex-wrap lg:flex-nowrap'>
                    <Headline
                        className='font-medium'
                        align={content.settings.buttonAllPosts.url ? "left" : "center"}
                        tag={content.headline.tag}
                        topline={content.headline.topline}
                    >
                        {content.headline.title}
                    </Headline>
                    {content.text && (
                        <Text className='prose md:text-md text-center'>{parse(content.text)}</Text>
                    )}
                    {content.settings.buttonAllPosts && (
                        <Button
                            as='link'
                            type='primary'
                            className='shrink-0'
                            href={content.settings.buttonAllPosts.url}
                        >
                            {content.settings.buttonAllPosts.title}
                        </Button>
                    )}
                </div>
                <div className='mt-5 lg:mt-20'>
                    {/* {!content.settings?.category && categoriesData && (
                        <div className='text-lg text-neutral font-medium flex justify-center gap-8 mb-12'>
                            <button
                                className={cn(
                                    "border-b border-transparent py-2 hover:text-on-primary transition",
                                    !category && "border-brand text-on-primary"
                                )}
                                onClick={() => {
                                    setCategory(false);
                                }}
                            >
                                {"Alle"}
                            </button>
                            {categoriesData.length >= 1 &&
                                categoriesData?.map((cat, index) => {
                                    return (
                                        <button
                                            className={cn(
                                                "border-b border-transparent py-2 hover:text-on-primary transition",
                                                category === cat.id &&
                                                    "border-brand text-on-primary"
                                            )}
                                            onClick={() => {
                                                setCategory(cat?.id);
                                            }}
                                            key={index}
                                        >
                                            {cat?.name}
                                        </button>
                                    );
                                })}
                        </div>
                    )} */}
                    {posts && (
                        <>
                            {content.settings.firstBig}
                            {content.settings.firstBig &&
                                posts
                                    .slice(0, 1)
                                    .map((post: any, index: number) => (
                                        <FirstPost
                                            post={post}
                                            key={index}
                                            translations={translations}
                                            locale={locale}
                                        />
                                    ))}
                            <div className='grid grid-cols-1 gap-x-8 gap-y-10 lg:gap-y-20 md:grid-cols-2 lg:grid-cols-3'>
                                {posts
                                    .slice(
                                        content.settings.firstBig ? 1 : 0,
                                        content.settings.firstBig
                                            ? content.settings.number + 1
                                            : content.settings.number
                                    )
                                    .map((post: any, index: number) => (
                                        <Post
                                            post={post}
                                            key={index}
                                            translations={translations}
                                            locale={locale}
                                        />
                                    ))}
                            </div>
                        </>
                    )}
                    {isLoading && (
                        <div className='flex justify-center m-8'>
                            <Loader color='#00ABB3' text='Beiträge werden geladen...' />
                        </div>
                    )}
                    {posts && posts.length < total && (
                        <div
                            className='mt-2'
                            onClick={() => {
                                setPerPage(perPage + 3);
                            }}
                        >
                            <Button as='button' type='primary'>
                                {translations.loadMore[locale]}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Section>
    );
}
